<template>
  <div class="flex flex-col items-center justify-center min-h-screen bg-gray-100 p-4">
    <vs-card class="w-full md:w-1/2 lg:w-1/3">
      <div class="text-center">
        <vs-avatar class="mb-4" size="large" :icon="icon" :color="color"></vs-avatar>
        <h1 class="text-3xl font-bold mb-4 text-gray-800">{{ messageTitle }}</h1>
        <p class="text-lg text-gray-600 mb-4">{{ messageBody }}</p>
        <div v-if="status === 'completed'" class="bg-gray-200 p-4 rounded-lg mb-4">
          <p class="text-sm text-gray-500">Reference</p>
          <p class="text-lg text-gray-800 font-semibold">{{ reference }}</p>
        </div>
      </div>
    </vs-card>
  </div>
</template>

<script>
export default {
  data() {
    return {
      status: '',
      reference: '',
      messageTitle: '',
      messageBody: '',
      icon: '',
      color: ''
    };
  },
  created() {
    this.status = this.$route.query.status || 'unknown';
    this.reference = this.$route.query.reference || 'N/A';
    this.handleStatus();
  },
  methods: {
    handleStatus() {
      switch (this.status) {
        case 'completed':
          this.messageTitle = 'Thank You!';
          this.messageBody = 'Your payment has been successfully processed.';
          this.icon = 'check_circle';
          this.color = 'success';
          break;
        case 'declined':
          this.messageTitle = 'Payment Declined';
          this.messageBody = 'Your payment was declined. Please try again or use a different payment method.';
          this.icon = 'close';
          this.color = 'danger';
          break;
        case 'pending':
          this.messageTitle = 'Payment Pending';
          this.messageBody = 'Your payment is currently pending. We will update you once the payment is processed.';
          this.icon = 'hourglass_empty';
          this.color = 'warning';
          break;
        case 'failed':
          this.messageTitle = 'Payment Failed';
          this.messageBody = 'There was an issue processing your payment. Please try again later.';
          this.icon = 'error';
          this.color = 'danger';
          break;
        case 'cancelled':
          this.messageTitle = 'Payment Cancelled';
          this.messageBody = 'Your payment has been cancelled.';
          this.icon = 'cancel';
          this.color = 'success';
          break;
        case 'Booked':
          this.messageTitle = 'Booking Confirmed';
          this.messageBody = 'Your booking has been confirm. Please pay upon picking up the car.';
          this.icon = 'check_circle';
          this.color = 'warning';
          break;
        case 'expired':
          this.messageTitle = 'Payment Expired';
          this.messageBody = 'Your payment request has expired. Please initiate a new payment.';
          this.icon = 'schedule';
          this.color = 'warning';
          break;
        default:
          this.messageTitle = 'Unknown Status';
          this.messageBody = 'The payment status is unknown. Please contact support for further assistance.';
          this.icon = 'help';
          this.color = 'dark';
          break;
      }
    }
  }
};
</script>

<style scoped>
/* Inline styles are used to handle TailwindCSS classes */
</style>
